var sidebar = require( './sidebar-menu' );

var scroll_load = ( function ( $ ) {

	// Pages to load in advance, before the user scrolls to them
	var PAGES_AHEAD = 2;
	// Number of pages that have already been loaded by the initial request
	var PAGES_PRE_LOADED = 1;
	// Container of pages
	var PAGES_CONTAINER = '.member-posts';

	var pages_loaded = PAGES_PRE_LOADED;
	var pages_loading = false;
	var enabled = true;
	var $pages_container = null;
	var scroll_points = [];
	var $spinner = null;

	var reset = function() {
		$( document ).off( 'scroll', _check_next_page );

		pages_loaded = 0;
		scroll_points = [];
		enabled = true;
		pages_loading = false;

		$pages_container.html( '' );

		_get_next_page();

		_check_next_page();

		$( document ).scroll( _check_next_page );
	};

	var _add_to_queue = function( value ) {
		scroll_points.push( value );
	};

	var _pop_queue = function() {
		scroll_points.shift();
	};

	var _process_new_page = function( $page ) {
		_insert_page( $page );
		pages_loaded++;
		pages_loading = false;

		if ( scroll_points.length > PAGES_AHEAD ) {
			_pop_queue();
		}

		_add_to_queue( $pages_container.height() );
	};

	var _init = function() {
		$pages_container = $( PAGES_CONTAINER );
		$spinner         = $pages_container.next( '.ajax-loader' );
		_add_to_queue( $pages_container.height() );
		_check_next_page();
	};

	var _get_next_page = function() {

		var data = {
			action: 'get_member_posts',
			scroll_load_nonce: ScriptData.scroll_load_nonce,
			query_vars: ScriptData.query_vars,
			page: pages_loaded + 1
		};

		loading();
		$.post( ScriptData.ajaxurl, data, _received_page );
		pages_loading = true;
	};

	var _received_page = function( response ) {
		if ( response.html ) {
			var $page = $( $.parseHTML( response.html ) );
			_process_new_page( $page );
			$( document ).trigger( 'pageloaded', [$page] );

			_check_next_page();
		} else {
			enabled = false;
			loaded();
		}
	};

	var _insert_page = function( $html ) {
		$pages_container.append( $html );
		sidebar.set_sidebar_container_height();

		loaded();
	};

	var _check_next_page = function() {
		if ( enabled && ! pages_loading ) {
			var get_next_page = false;

			var distance_from_bottom = scroll_points[0] - window.scrollY + $pages_container.offset().top - $( window ).height();
			if ( distance_from_bottom < 0 ) {
				get_next_page = true;
			}

			if ( scroll_points.length <= PAGES_AHEAD ) {
				get_next_page = true;
			}

			if ( get_next_page ) {
				_get_next_page();
			}
		}
	};

	var loading = function() {
		$spinner.fadeIn();
	};

	var loaded = function() {
		$spinner.fadeOut();
	};

	if ( $( '.member-posts' ).length > 0 ) {
		$( document ).on( 'ready', _init );
		$( document ).scroll( _check_next_page );
	}

	return {
		reset: reset
	};

} ) ( jQuery );

module.exports = scroll_load;
